import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as rolesApi from "./api";

export function useRolesAdmin() {
  return useQuery({ queryKey: ["roles"], queryFn: rolesApi.listRoles });
}

export function usePermissionCatalogue() {
  return useQuery({
    queryKey: ["permissions"],
    queryFn: rolesApi.listPermissions,
    staleTime: 30 * 60_000, // the catalogue is code-defined; it barely changes
  });
}

function useInvalidateRoles() {
  const qc = useQueryClient();
  return () => {
    void qc.invalidateQueries({ queryKey: ["roles"] });
    // A user's role badge / the role dropdown may reflect a rename.
    void qc.invalidateQueries({ queryKey: ["users"] });
  };
}

export function useCreateRole() {
  const invalidate = useInvalidateRoles();
  return useMutation({ mutationFn: rolesApi.createRole, onSuccess: invalidate });
}

export function useUpdateRole() {
  const invalidate = useInvalidateRoles();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<rolesApi.RoleBody> }) =>
      rolesApi.updateRole(id, body),
    onSuccess: invalidate,
  });
}

export function useDeleteRole() {
  const invalidate = useInvalidateRoles();
  return useMutation({ mutationFn: rolesApi.deleteRole, onSuccess: invalidate });
}
